import React from "react";
import {Login} from "./auth/Login";
import {Globals} from "../controllers/Globals";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {ResetPassword} from "./auth/ResetPassword";
import packageJson from "../../../package.json";
import {ForgotPassword} from "./auth/ForgotPassword";

export function AppLogout(){
	return (
		<div style={{minHeight:'100vh', display:'flex', justifyContent:'center', alignItems:'center', padding:"var(--padding-2)"}}>
			<div className={"card"} style={{maxWidth:'40rem', width:'100%', padding:0}}>
				<img src={require("../media/images/line.png")} style={{display:'block', width:'100%', height:3, marginTop:10}} alt={"risk-line"} />
				<Router ref={(ref)=>{ Globals.router = ref }} >
					<Switch>
						<Route path="/reset-password" exact={false} ><ResetPassword /></Route>
						<Route path="/forgot-password" exact={false} ><ForgotPassword /></Route>
						<Route path="/*" exact={false}><Login /></Route>
					</Switch>
				</Router>
			</div>
			<div className={'a-r-b f-9'} style={{margin:'0 10px 5px 0'}}>v.{packageJson.version}</div>
		</div>
	)
}
